'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactBinding = require('react-binding');

var _reactBinding2 = _interopRequireDefault(_reactBinding);

var WidgetRenderer = (function (_React$Component) {
	_inherits(WidgetRenderer, _React$Component);

	function WidgetRenderer() {
		_classCallCheck(this, WidgetRenderer);

		_get(Object.getPrototypeOf(WidgetRenderer.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(WidgetRenderer, [{
		key: 'render',
		value: function render() {
			var box = this.props.node;
			var widget = this.props.widget;
			if (widget === undefined) {
				return _react2['default'].DOM.span(null, 'Component ' + box.elementName + ' is not register among widgets.');
			}

			//get default props
			var bindingProps = _lodash2['default'].reduce(box.bindings, function (memo, value, key) {
				memo[key] = undefined;
				return memo;
			}, {});

			var defaultProps = _lodash2['default'].merge(bindingProps, _lodash2['default'].merge(_lodash2['default'].cloneDeep(widget.defaultProps) || {}, box.props));

			//apply binding
			var props = this.props.dataBinder !== undefined ? WidgetRenderer.bindProps(defaultProps, box.bindings, this.props.dataBinder, !!this.props.designer) : defaultProps;

			//apply property resolution strategy -> default style -> custom style -> local style
			var customStyle = this.props.customStyle;
			var widgetStyle = {};
			if (customStyle !== undefined) widgetStyle = _lodash2['default'].merge(widgetStyle, _lodash2['default'].cloneDeep(customStyle));
			props = _lodash2['default'].merge(widgetStyle, props);

			return _react2['default'].createElement(widget, props, props.content !== undefined ? _react2['default'].DOM.div({ dangerouslySetInnerHTML: { __html: props.content } }) : null);
		}
	}]);

	return WidgetRenderer;
})(_react2['default'].Component);

exports['default'] = WidgetRenderer;
;

WidgetRenderer.bindProps = function (clonedProps, bindings, dataBinder, isDesignMode) {
	var props = clonedProps; //_.cloneDeep(node.props);

	//go through all properties
	for (var propName in props) {
		var prop = props[propName];

		var bindingProps = bindings && bindings[propName];

		//if binding -> replace binding props
		if (bindingProps !== undefined) {

			if (!!bindingProps.path) {
				//apply binding
				var converter;
				if (!!bindingProps.converter && !!bindingProps.converter.compiled) {
					converter = eval(bindingProps.converter.compiled);

					if (typeof converter === 'string' || converter instanceof String) {
						var sharedConverter = dataBinder.customCode && dataBinder.customCode[converter];
						if (sharedConverter === undefined) continue;
						converter = sharedConverter;
					}
				}
				var binding = _reactBinding2['default'].bindTo(dataBinder, bindingProps.path, converter, bindingProps.converterArgs);

				if (!isDesignMode && bindingProps.mode === 'TwoWay') {
					//two-way binding
					props.valueLink = binding;
					props[propName] = null;
				} else {
					//one-way binding
					//box[propName] = dataBinder.value[prop.Path];
					props[propName] = binding.value;
				}
			} else {
				//binding is not correctly set - do not apply binding
				props[propName] = undefined;
			}
		}
	}
	return props;
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-html-pages-renderer/lib/WidgetRenderer.js
 ** module id = 485
 ** module chunks = 0
 **/